(function () {
    'use strict';

    angular.module("imApp").factory("invoiceMakeMultiOrdersService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1759,
                    parameters: parms || {}
                });
            },
            listMultiOrders: function (parms) {
                return $ihttp.post({
                    method: 1760,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
